<template>
  <div class="title-bar">
    <!-- <div class="logo">
      <img src="/logo.jpg" alt="Stakes Logo" height="70" width="70" />
    </div> -->
    <div class="title-section-left">
      <div class="file-name" v-if="['game', 'result'].includes($route.name)">
        {{ fileName.split(".tsv")[0] }}
      </div>
      <div class="total-numbers" v-if="['game', 'result'].includes($route.name)">
        <span v-if="numRounds">
          {{ `[${numRounds} x ${numPlayers} x ${numDirects}]` }}
        </span>
        <span class="progress-details" v-if="
          $route.name === 'game' &&
          ['Question', 'Answer', 'ShowAnswer'].includes(questionDisplayMode)
        ">
          <strong>{{
            `[${displayCurrentQuestionNo}/${totalQuestions}]`
          }}</strong>
        </span>
      </div>
    </div>

    <div class="title-section-middle">
      <div class="current-status-bar" v-if="$route.name === 'game'">
        <div class="current-numbers" v-if="!finishGame">
          <span class="title-component">Round {{ getCurrent.round }} </span>
          <span class="title-component">Player {{ getCurrent.player + 1 }}</span>
          <span class="title-component question-number">Question {{ getCurrent.question }}</span>
        </div>
        <div v-else>
          <div class="end-game-banner">GAME OVER!</div>
        </div>
      </div>
      <div v-else-if="$route.name === 'result'">
        <div class="results-banner">
          <span>Results</span>
          <span v-if="leagueMatch && matchNumber">{{ ` (Match #: ${matchNumber})` }}</span>
        </div>
      </div>
      <div v-else-if="$route.name === 'settings'">
        <div class="settings-banner">Settings</div>
      </div>
      <div v-else-if="$route.name === 'about'" class="settings-banner">
        About
      </div>
      <div v-else-if="$route.name === 'playerHistory'" class="settings-banner">
        Player History
      </div>
    </div>

    <div class="title-section-right">
      <div v-if="showRightIcons">
        <!-- <font-awesome-icon icon="fa=solid fa-floppy-disk" class="settings-button" title="Save Current Game to DB"
          v-if="$route.name === 'game'" @click="saveCurrentGame" /> -->
        <font-awesome-icon title="Settings" icon="fa-solid fa-cog" class="settings-button" v-if="
          $route.name === 'game' ||
          $route.name === 'about' ||
          $route.name === 'playerHistory'
        " @click="$router.push('/settings')" />
        <font-awesome-icon icon="fa=solid fa-copy" class="settings-button" title="Copy WikiQuiz URL"
          v-if="$route.name === 'game' && gameType === 'mimir'" @click="copyCurrentGameUrl" />
        <font-awesome-icon icon="fa-solid fa-clock-rotate-left" title="Player History" class="settings-button"
          v-if="$route.name === 'settings'" @click="$router.push('/player-history')" />
        <font-awesome-icon icon="fa-regular fa-circle-question" title="About Page" class="settings-button"
          v-if="$route.name === 'settings'" @click="$router.push('/about')" />
      </div>
      <div class="timer-section" v-if="$route.name === 'game'">
        <TimerComponent />
      </div>
      <div v-if="$route.name === 'result'" class="reader-container">
        <div v-if="readerName" class="reader-details">
          <div>Reader:</div>
          <div>{{ readerName }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
import TimerComponent from "./TimerComponent.vue";

export default {
  name: "TitleBar",
  components: {
    TimerComponent,
  },
  computed: {
    ...mapGetters(["getCurrent", "getWikiQuizUrl"]),
    ...mapState([
      "finishGame",
      "numRounds",
      "numPlayers",
      "numDirects",
      "showSettings",
      "currentQuestionNo",
      "totalQuestions",
      "fileName",
      "gameType",
      "readerName",
      "questionDisplayMode",
      "leagueMatch",
      "matchNumber"
    ]),
    showRightIcons() {
      return ["settings", "about", "result", "game", "playerHistory"].includes(
        this.$route.name
      );
    },
    displayCurrentQuestionNo() {
      if (this.questionDisplayMode === "Answer") {
        return this.currentQuestionNo;
      } else {
        return this.currentQuestionNo + 1;
      }
    },
  },
  methods: {
    ...mapActions(["saveCurrentGameStatus"]),
    async copyCurrentGameUrl() {
      const url = this.getWikiQuizUrl;
      await navigator.clipboard.writeText(url);

      this.$toast.open({
        message: "WikiQuiz Url copied to clipboard",
        duration: 3000,
        type: "success",
      });
    },
    async saveCurrentGame() {
      const response = await this.saveCurrentGameStatus()
      console.log(response)
      // this.saveCurrentGameStatus().then(resp => {
      //   console.log(resp);
      //   this.$toast.open({
      //     message: "Game saved successfully",
      //     duration: 3000,
      //     type: "success",
      //   });
      // }).catch(err => {
      //   console.log(err);
      //   this.$toast.open({
      //     message: "Error saving game",
      //     duration: 3000,
      //     type: "error",
      //   });
      // })
    }
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Lemonada&display=swap");

.title-bar {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  background-color: black;
  height: 70px;
}

.title-section-left {
  display: flex;
  flex-direction: column;
  margin-left: 15px;
  align-items: flex-start;
}

.title-section-middle {
  line-height: 70px;
}

.title-section-right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.total-numbers {
  white-space: nowrap;
  font-size: 2.75vmin;
  color: #dddddd;
}

.progress-details {
  margin-left: 20px;
  font-size: 2.75vmin;
  color: #dddddd;
}

.file-name {
  line-height: 35px;
  height: 35px;
  font-size: 2vmin;
  color: #dddddd;
  text-align: left;
  overflow: hidden;
}

.reader-details {
  margin-right: 10px;
  text-align: left;
  color: #dddddd;
  font-size: 2.5vmin;
  text-align: right;
  line-height: 35px;
  margin-right: 10px;
}

.current-status-bar {
  font-size: 3vmin;
  color: #dddddd;
  flex-grow: 1;
  line-height: 70px;
}

.current-numbers {
  white-space: nowrap;
}

@media (max-width: 800px) {

  .title-section-middle,
  .current-status-bar {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .current-numbers {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    line-height: 3vmin;
  }
}

.title-component {
  margin: 0 10px;
}

.question-number {
  font-weight: bold;
}

.end-game-banner {
  padding-right: 100px;
  font-size: 3.5vmin;
  color: white;
  font-weight: bold;
}

.settings-banner,
.results-banner {
  font-size: 3.5vmin;
  color: white;
  /* font-weight: bold; */
}

.settings-button {
  /* background-color: #dddddd; */
  font-size: 3vmin;
  color: #eee;
  /* font-weight: bold; */
  height: min(36px, 3vmin);
  padding: 0 5px;
  border: none;
  border-radius: 5px;
  align-self: center;
  margin-right: 10px;
  cursor: pointer;
}
</style>
